export default __webpack_public_path__ + "svg/ceo/sustainability.svg?837b4109";